import React, { useRef, useCallback } from 'react';
import classNames from 'classnames';
import styles from './Sidebar.scss.js';
import Icon from '../../Icons/Icons/Icon/Icon.js';
import useClickOutside from '../Hooks/useClickOutside/useClickOutside.js';
import { Theme } from '../../../helpers/enums/themes/themeTypes.js';

const Sidebar = _ref => {
  let {
    theme = Theme.WHITE,
    width = 288,
    mode = 'sidebar',
    isOpen,
    onClose = () => {},
    children,
    closeOnOutsideClick = false,
    shouldShowCloseButton = true
  } = _ref;
  const sidebarRef = useRef(null);
  const handleClose = useCallback(() => {
    if (closeOnOutsideClick) {
      if (mode === 'overlay') {
        onClose();
      }
    }
  }, [closeOnOutsideClick, mode, onClose]);
  useClickOutside(sidebarRef, handleClose);
  return /*#__PURE__*/React.createElement("div", {
    ref: sidebarRef,
    className: classNames(styles.container, {
      [styles[`container--${theme}`]]: true,
      [styles[`container--${mode}`]]: true,
      [styles['container--hidden']]: !isOpen && mode === 'overlay'
    }),
    style: {
      width
    }
  }, shouldShowCloseButton && mode === 'overlay' && /*#__PURE__*/React.createElement("div", {
    className: styles.header
  }, /*#__PURE__*/React.createElement("button", {
    className: styles['close-button'],
    onClick: () => onClose(),
    "aria-label": "Close Sidebar"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "system-ui-x-close-darker"
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, children));
};
var Sidebar$1 = Sidebar;

export { Sidebar$1 as default };
//# sourceMappingURL=Sidebar.js.map
